import {FC, useMemo, useState} from 'react'
import {Boxes, Building2, KeyRound, Settings2, ShieldCheck} from 'lucide-react'

import {PageTitle} from '../../../_metronic/layout/core'
import {isSuperAdmin} from '../../modules/auth/core/Auth'
import {AccessMatrixFiltersProvider} from '../../components/AccessMatrixFilters'
import Companys from './Companys'
import {CompanyFeatureMatrix} from './FeatureMatrix'
import PermissionMatrix from './PermissionMatrix'
import CompanyConfig from './settings/CompanyConfig'
import '../users/users-admin.css'
import '../users/users-admin-extra.css'
import './company-admin.css'

type TabId = 'companys' | 'menu-permissions' | 'features' | 'config'

const allTabs = [
  {id: 'companys' as const, label: 'Empresas', description: 'Cadastros e status', icon: Building2},
  {
    id: 'menu-permissions' as const,
    label: 'Permissões',
    description: 'Produtos e menus',
    icon: KeyRound,
  },
  {
    id: 'features' as const,
    label: 'Funcionalidades',
    description: 'Recursos por empresa',
    icon: Boxes,
  },
  {
    id: 'config' as const,
    label: 'Configurações',
    description: 'Domínios permitidos',
    icon: Settings2,
  },
]

const CompanyTabs: FC = () => {
  const [activeTab, setActiveTab] = useState<TabId>('companys')
  const tabs = useMemo(() => allTabs.filter((tab) => tab.id !== 'config' || isSuperAdmin()), [])

  return (
    <div className='user-admin company-admin'>
      <PageTitle>Administração de empresas</PageTitle>

      <section className='user-admin__hero'>
        <div className='user-admin__hero-icon' aria-hidden='true'>
          <ShieldCheck size={24} />
        </div>
        <div>
          <span className='user-admin__eyebrow'>Organizações e governança</span>
          <h1>Administração de empresas</h1>
          <p>Centralize cadastros, acessos, funcionalidades e regras de domínio em um só lugar.</p>
        </div>
      </section>

      <nav
        className={`user-admin__tabs company-admin__tabs company-admin__tabs--${tabs.length}`}
        aria-label='Seções da administração de empresas'
      >
        {tabs.map((tab) => {
          const Icon = tab.icon
          const isActive = activeTab === tab.id

          return (
            <button
              key={tab.id}
              type='button'
              className={`user-admin__tab ${isActive ? 'is-active' : ''}`}
              aria-current={isActive ? 'page' : undefined}
              onClick={() => setActiveTab(tab.id)}
            >
              <span className='user-admin__tab-icon'>
                <Icon size={19} />
              </span>
              <span>
                <strong>{tab.label}</strong>
                <small>{tab.description}</small>
              </span>
            </button>
          )
        })}
      </nav>

      <AccessMatrixFiltersProvider>
        <main className='user-admin__content'>
          {activeTab === 'companys' && <Companys />}
          {activeTab === 'menu-permissions' && <PermissionMatrix />}
          {activeTab === 'features' && <CompanyFeatureMatrix />}
          {activeTab === 'config' && isSuperAdmin() && <CompanyConfig />}
        </main>
      </AccessMatrixFiltersProvider>
    </div>
  )
}

export default CompanyTabs
